import React from "react";
import { format, parse } from "date-fns";
import { OperatingHour } from "@/types/branch";

const formatTime = (time: string) => {
  const parsedTime = parse(time, "HH:mm:ss", new Date());
  return format(parsedTime, "hh:mm a"); // Use 'hh:mm a' for 12-hour format with AM/PM
};

const getMinutesFromTimeString = (timeString: string) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  return hours * 60 + minutes;
};

const sortTimeRanges = (timeRanges: string[]) => {
  return timeRanges.sort((a, b) => {
    const timeA = a.split(" - ")[0]; // Get start time of first range
    const timeB = b.split(" - ")[0]; // Get start time of second range
    return getMinutesFromTimeString(timeA) - getMinutesFromTimeString(timeB);
  });
};

const mergeOperatingHours = (
  hours: OperatingHour[],
): Record<string, string[]> => {
  const mergedHours: Record<string, string[]> = {};

  hours.forEach((hour) => {
    if (!mergedHours[hour.day]) {
      mergedHours[hour.day] = [];
    }
    mergedHours[hour.day].push(
      `${formatTime(hour.open_time)} - ${formatTime(hour.close_time)}`,
    );
  });

  // Sort time ranges for each day
  Object.keys(mergedHours).forEach((day) => {
    mergedHours[day] = sortTimeRanges(mergedHours[day]);
  });

  return mergedHours;
};

const MobileOperationalTimes: React.FC<{ operatingHours: OperatingHour[] }> = ({
  operatingHours,
}) => {
  const mergedHours = mergeOperatingHours(operatingHours);
  const daysOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return (
    <ul className="mobile-operational-times">
      {daysOrder.map((day) => (
        <li key={day} className="flex justify-between items-start">
          <span className="day font-bold text-base">{day}</span>
          <div className="times">
            {mergedHours[day] ? (
              mergedHours[day].map((timeRange, index) => (
                <div className="font-normal text-base" key={index}>
                  {timeRange}
                </div>
              ))
            ) : (
              <span className="font-normal text-base">Closed</span>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default MobileOperationalTimes;
